var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.PendingPickingOrder"),
                    name: "tabPending",
                    lazy: true
                  }
                },
                [_c("tab-pending", { on: { print: _vm.onListPrintHandler } })],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.PickingList"),
                    name: "tabPickingList",
                    lazy: true
                  }
                },
                [
                  _c("tab-picking-list", {
                    on: { print: _vm.onListPrintHandler }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.WarehouseReleaseReceipt"),
                    name: "tabWarehouseRelease",
                    lazy: true
                  }
                },
                [
                  _c("tab-warehouse-release", {
                    on: { print: _vm.onListPrintHandler }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("print-data-dialog", {
        ref: "printDataDialog",
        attrs: {
          "v-if": _vm.printDataDialog.visible,
          visible: _vm.printDataDialog.visible,
          row: _vm.printDataDialog.row,
          "print-params": _vm.printDataDialog.printParams
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.printDataDialog, "visible", $event)
          },
          close: function($event) {
            _vm.printDataDialog.visible = false
          },
          printDataHandler: _vm.printDataHandler,
          refresh: function() {}
        }
      }),
      _c("cargo-template-selector-dialog", {
        ref: "templateSelectorDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }